import React from "react";
import { LinkContainer } from "react-router-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { Nav } from "react-bootstrap";
import { useAppContext } from "../context/appContext";
import { useNavigate } from "react-router-dom";

const LogoutIcon = ({ setSelectedTenant, setUsersSelectedTenant }) => {
  const { logoutUser } = useAppContext();
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (setSelectedTenant) {
      setSelectedTenant(null);
    }
    if (setUsersSelectedTenant) {
      setUsersSelectedTenant(null);
    }

    await logoutUser();
    navigate("/");
  };

  return (
    <Nav className="ml-auto">
      <LinkContainer to="/" onClick={handleLogout}>
        <Nav.Link className="d-flex align-items-center">
          <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" style={{ color: "white" }} />
          <span style={{ color: "white" }}>Logout</span>
        </Nav.Link>
      </LinkContainer>
    </Nav>
  );
};

export default LogoutIcon;
